// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactInfo_container__ZWYif","flex":"ContactInfo_flex__21rj1"};